module.exports = __webpack_public_path__ + "media/images/shared/icon-photo-dbdd9293f67e2b804a68e7b491d14c68.png";